import { createSelector } from "reselect";

export const getData = state => state.app.ums;

export const getCustomer = createSelector(getData, ({ customer }) => customer);
export const getCustomers = createSelector(
  getData,
  ({ customers }) => customers
);
